var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDateWatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-date-watch",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.052,
    height: 26.112,
    viewBox: "0 0 26.052 26.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2312",
    "data-name": "Ret\\xE2ngulo 2312",
    width: 26.052,
    height: 26.112,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4344",
    "data-name": "Grupo 4344",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2346",
    "data-name": "Caminho 2346",
    d: "M13.835,26.112H12.207a1.784,1.784,0,0,0-.221-.044,12.565,12.565,0,0,1-4.032-.98A13.064,13.064,0,0,1,10.75.2c.484-.08.971-.135,1.457-.2h1.629c.065.014.13.032.2.042.669.1,1.347.166,2.005.317a13.021,13.021,0,0,1,9.817,10.447c.08.476.132.956.2,1.435v1.632c-.014.066-.033.131-.043.2-.088.6-.145,1.215-.268,1.812a13.045,13.045,0,0,1-10.45,10.03c-.483.078-.97.135-1.456.2m-.823-1.53a11.526,11.526,0,1,0-11.5-11.541,11.535,11.535,0,0,0,11.5,11.541",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2347",
    "data-name": "Caminho 2347",
    d: "M242.139,117.419h4.145v1.506h-5.647v-8.153h1.5Z",
    transform: "translate(-228.364 -105.122)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2348",
    "data-name": "Caminho 2348",
    d: "M105.86,107.709l-.983-.985,1-1.01.985.982-1.006,1.013",
    transform: "translate(-99.528 -100.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2349",
    "data-name": "Caminho 2349",
    d: "M367.1,105.008l1.019,1.02-1.018,1.021-1.019-1.02,1.018-1.021",
    transform: "translate(-347.41 -99.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2350",
    "data-name": "Caminho 2350",
    d: "M104.563,367.887l1-1,1.023,1.028-1,1-1.019-1.028",
    transform: "translate(-99.23 -348.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2351",
    "data-name": "Caminho 2351",
    d: "M366.049,367.9l1.013-1.016,1.022,1.027-1.018,1.017-1.016-1.028",
    transform: "translate(-347.38 -348.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2308",
    "data-name": "Ret\\xE2ngulo 2308",
    width: 1.499,
    height: 1.498,
    transform: "translate(12.274 2.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2309",
    "data-name": "Ret\\xE2ngulo 2309",
    width: 1.497,
    height: 1.503,
    transform: "translate(2.845 12.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2310",
    "data-name": "Ret\\xE2ngulo 2310",
    width: 1.496,
    height: 1.497,
    transform: "translate(21.701 12.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2311",
    "data-name": "Ret\\xE2ngulo 2311",
    width: 1.494,
    height: 1.497,
    transform: "translate(12.278 21.753)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDateWatch);
export default __webpack_public_path__ + "static/media/icon-date-watch.1feb3e5be647e77dbd40b5a3e281863e.svg";
export { ForwardRef as ReactComponent };